<template>
  <div class="header">
    <div class="new_menu">
      <div class="logo">
        <a @click="onClickMain">
          <img src="@/assets/img/etners-main/eskiosk_logo.png" style="width: 140px;">
        </a>
      </div>
      <div style="width:500px;" class="right">
        <ul>
          <li @click="logoutProcess">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>로그아웃
          </li>
          <li class="name" :title="userNm">
            {{ userNm.length > 6 ? userNm.substring(0, 6) + '...' : userNm }}님
          </li>
          <li class="alert-list">
          <div class="alert-count">{{ notiList.length }}</div>
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
          </svg>알림
          <p>
            <ol>
              <li>
                <div class="all_check" @click="onClickReadAllNoti"><span class="k-icon k-i-check"></span>모두읽음</div>
              </li>
              <li v-if="notiList.length < 1">
                <div class="w100 txt_c">알림이 없습니다.</div>
              </li>
              <li v-else v-for="item in notiList" class="unread" @click="onClickNoti(item)">
                <div v-if="false" class="fl w50 working_label"><span class="gray">일반</span></div>
                <div class="fr w50 txt_r">{{ item.frstRgstDt }}</div>
                <div class="w100"><b>{{ item.notiTitle }}</b></div>
                <div class="w100">{{ item.notiContents }}</div>
              </li>
            </ol>
          </p>
        </li>
          <li>
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
            <router-link :to="{ name: 'MyPage'}">마이페이지</router-link>
          </li>
        </ul>
      </div>
      <div class="menu1">
        <ul>
          <router-link v-for="menu in menuData.depth1MenuList" :key="menu.menuId" tag="li" :to="menu.urlLink" @click.native="e => fnOnClickMenu(e, menu.menuId, null)">
            <a :class="!$route.path.includes('/main') && !$route.path.includes('/mypage') && activeDepth1MenuId === menu.menuId ? ' active' : ''">{{ menu.menuNm }}</a>
            <ol class="sub_menu" v-if="menuData.depth2MenuObj[menu.menuId] !== undefined && menuData.depth2MenuObj[menu.menuId].length > 0">
              <router-link v-for="subMenu in menuData.depth2MenuObj[menu.menuId]" :key="subMenu.menuId" tag="li" :to="subMenu.urlLink" :class="activeDepth2MenuId === subMenu.menuId ? ' on' : ''"
                           @click.native="e => fnOnClickMenu(e, menu.menuId, subMenu.menuId)">
                {{ subMenu.menuNm }}
              </router-link>
            </ol>
          </router-link>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import ApiUtil from "@/api/api.util";
import ApiConfig from "@/api/api.config";
import $ from 'jquery'
import EtnersCommonUtil from '@/common/etners.common.util'

export default {
  mounted: function () {
    const vm = this

    // 메뉴
    let $firstmenu = $('.menu1 > ul > li'), $header = $('.menu1')
    $firstmenu.mouseenter(() => (vm.mouseEnter($header))).mouseleave(() => (vm.mouseLeave($header)))
    vm.startInterval(60) // 60초 마다
  },
  methods: {
    onClickMain: function (e) {
      const vm = this
      if (vm.$route.name === 'LogisticsDashBoard') {
        return
      }
      vm.$router.push({
        name: 'LogisticsDashBoard',
      })
    },
    // 1depth, 2depth 메뉴 클릭 이벤트
    fnOnClickMenu: function(e, activeDepth1MenuId, activeDepth2MenuId) {
      const vm = this
      e.stopPropagation()
      this.activeDepth1MenuId = activeDepth1MenuId
      this.activeDepth2MenuId = activeDepth2MenuId

      const isMobile = function (currentDevice, pcDevice) {
        return currentDevice && pcDevice.indexOf(currentDevice.toLowerCase()) < 0
      }

      // PC용 플랫폼 나열
      const pcDevice = 'win16|win32|win64|mac|macintel'
      // 현재 접속한 디바이스 환경
      const currentDevice = navigator.platform
      // if(EtnersCommonUtil.isNotEmpty(activeDepth2MenuId)){
      if(EtnersCommonUtil.isNotEmpty(activeDepth2MenuId) && isMobile(currentDevice, pcDevice)){
        let $header = $('.menu1')
        vm.mouseLeave($header)

      }
      // else if(EtnersCommonUtil.isEmpty(activeDepth2MenuId)){
      else if(EtnersCommonUtil.isEmpty(activeDepth2MenuId) && isMobile(currentDevice, pcDevice)){
        let $header = $('.menu1')
        vm.mouseEnter($header)
      }
    },

    setActiveMenu (activeDepth1MenuId, activeDepth2MenuId) {
      this.activeDepth1MenuId = activeDepth1MenuId
      this.activeDepth2MenuId = activeDepth2MenuId
    },

    mouseEnter ($header) {
      // depth2 메뉴 영역 크기에따라 동적으로 변경
      let defaultMenuHeight = 120
      let rowMenuHeight = 32
      let targetHeight = defaultMenuHeight + (rowMenuHeight * this.depth2MenuLength)
        $header.addClass('.menubdn')
        $header.stop().animate({
          height: `${targetHeight}px`
        }, 200)
    },
    mouseLeave ($header) {
          $header.stop().animate({
            height: '80px'
          }, 200, function() {

            // when completed
            $header.removeClass('menubdn')
          })
    },

    logoutProcess: function () {
      kendo.confirm('로그아웃하시겠습니까?').done(function () {
        sessionStorage.clear()
        setTimeout(function () {
          window.location.href = '/login'
        }, 300)
      })
    },

    startInterval: function(seconds){
      const vm = this
      vm.readNotiList()
      return setInterval(function(){
        vm.readNotiList()
      },seconds*1000)
    },

    readNotiList: function () {
      const vm = this
      let url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/manage/noti/getNotiList.json`
      let params = {
        loginUserToken: vm.loginUserToken
      }

      ApiUtil.post(url, params, {isShowLoadingBar : false}).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          return false
        }
        if (response.data.resultStatus.messageCode !== '2000') {
          if (response.data.resultStatus.messageCode === '4015') {
            // 토큰 만료 -> 로그아웃 처리
            sessionStorage.clear()
            setTimeout(function () {
              window.location.href = '/login'
            }, 300)
          }
          return false
        }
        vm.notiList = response.data.resultData
      })
    },

    onClickReadAllNoti: function () {
      const vm = this
      if (vm.notiList.length < 1) {
        return
      }
      let notiIdList = []
      for(let notiInfo of vm.notiList) {
        notiIdList.push(notiInfo.notiId)
      }
      vm.updateNotiStatus(notiIdList)
    },

    onClickNoti: function (target) {
      const vm = this
      vm.updateNotiStatus([target.notiId])
      
      const targetIdList = EtnersCommonUtil.isEmpty(target.targetId) ? [] : target.targetId.split(',')
      if (targetIdList.length > 1 || targetIdList.length === 0) {
        // 목록으로 이동
        sessionStorage.setItem("NOTI_PARAMS", kendo.stringify(JSON.parse(target.targetData)))
        location.href = `${target.targetUrl}`
      } else {
        // 상세로 이동
        location.href = `${target.targetUrl}/${target.targetId}`
      }
    },

    updateNotiStatus: function (notiIdList) {
      const vm = this
      // 읽음 상태로 업데이트
      let url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/manage/noti/updateNoti.json`
      let params = {
        loginUserToken: vm.loginUserToken,
        notiIdList: notiIdList,
        isPopUp: false,
      }

      ApiUtil.post(url, params).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          return false
        }
        if (response.data.resultStatus.messageCode !== '2000') {
          return false
        } else {
          vm.readNotiList()
        }
      })
    },
  },
  data: function () {
    /**********************************************************************
     * 메인 메뉴 관련 로직 구현분
     **********************************************************************/
    const sessionLoginUserData = sessionStorage.getItem('loginUserData')
    const loginUserToken = sessionStorage.getItem('loginUserToken')

    let existLoginUserDataFl = false
    let loginUserObj
    let originalMenuData = []

    let userNm = ''
    let depth1MenuList
    let depth2MenuObj
    let depth2MenuLength

    if (sessionLoginUserData) {
      loginUserObj = JSON.parse(sessionLoginUserData)
      originalMenuData = loginUserObj.authMenuList
      userNm = loginUserObj.userNm

      // depth1 메뉴 리스트 (중복 제거)
      depth1MenuList = [...new Map(
          originalMenuData.filter(menuItem => {
            return menuItem.wmGbn === '01' && menuItem.superMenuId === null
          })
              .map(filterdMenuItem => {
                return [filterdMenuItem.menuId, filterdMenuItem]
              })).values()]

      // depth2 메뉴 key object
      depth2MenuObj = {}
      originalMenuData.filter(menuItem => {
        return menuItem.superMenuId !== 0
      })
          .forEach(filterdMenuItem => {
            if (depth2MenuObj[filterdMenuItem.superMenuId] === undefined) {
              depth2MenuObj[filterdMenuItem.superMenuId] = [filterdMenuItem]
            } else {
              depth2MenuObj[filterdMenuItem.superMenuId].push(filterdMenuItem)
            }
          })
      // depth2 메뉴 최대길이
      depth2MenuLength = Math.max(...Object.values(depth2MenuObj).map(arr => arr.length));

    }
    existLoginUserDataFl = true

    return {
      loginUserToken: loginUserToken,
      userNm: userNm,
      loginUserObj: loginUserObj,
      menuData: {
        depth1MenuList,
        depth2MenuObj
      },
      activeDepth1MenuId: '',
      activeDepth2MenuId: '',
      depth2MenuLength: depth2MenuLength,

      notiList: [],
    }
  }
}
</script>
<style scoped>
.new_menu .menu1 ul>li {
  width: auto;
  font-size: 14px;
  padding: 0 30px;
  text-align: center;
}
.new_menu .right {
  width: 15%;
}

.new_menu .menu1 ul>li>a:hover,
.new_menu .menu1 ul li>.on {
  border-bottom: 1px solid #333;
}
.new_menu .menu1 ul>li>.active {
  border-bottom: 1px solid #333;
}
.new_menu .menu1>ul>li .sub_menu li {
  text-align: left;
  font-size: 14px;
  white-space: nowrap;
  /* color: #fff; */
  font-weight: 500;
}

</style>
